import { useSite } from "~/contexts";
import { HEADING_FONT_CLASS, type HeadingFont } from "~/hec/utils/heading-font";

/**
 * Per-site heading font class. FSA renders headings in
 * `WT Volkolak Sans Display` (`font-display`); HSA + WDH use
 * `Volkolak Serif` (`font-serif`). Mirrors the production
 * `fonts.css` per-site choice for category/carousel headings.
 * An author-picked `font` (Builder font dropdown) wins over the site default.
 */
export const useHeadingFontClass = (font?: HeadingFont) => {
  const { site } = useSite();
  if (font) return HEADING_FONT_CLASS[font];
  return site.id === "FSASTORE" ? "font-display" : "font-serif";
};
